import { memo } from 'react';
import { Alert, Button } from '@amzn/awsui-components-core';

/**
 * Shown when a quality check scan runs past its timeout. The scan may still be
 * running server-side, so the author's only path forward is to reload the page.
 */
export const ScanTimeoutAlert = memo(function ScanTimeoutAlert() {
  return (
    <Alert
      type="warning"
      action={
        <Button variant="inline-link" onClick={() => window.location.reload()}>
          Refresh page
        </Button>
      }
    >
      The scan is taking longer than expected. Refresh the page to try again. If it keeps happening
      after a few tries, please contact APG support.
    </Alert>
  );
});
